import { render, staticRenderFns } from "./NeighborhoodStat.vue?vue&type=template&id=74a351b0&scoped=true&"
import script from "./NeighborhoodStat.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodStat.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodStat.vue?vue&type=style&index=0&id=74a351b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a351b0",
  null
  
)

export default component.exports